<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/users">Users</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">{{ this.$store.state.user.name || 'No name' }}</a></li>
      </ul>
    </nav>

    <div class="columns">
      <div class="column is-8 is-offset-1">
        <p class="title is-4">{{ this.$store.state.user.name || 'No name' }}</p>
        <p><span class="has-text-grey">User ID:</span> {{ $route.params.user_id }}</p>
        <p>
          <span class="has-text-grey">Email:</span>
          <span v-if="this.$store.state.user.verified === false" class="icon has-text-warning" title="Email is not confirmed">
            <i class="fa fa-warning"></i>
          </span>{{ this.$store.state.user.email }}
        </p>
        <p><span class="has-text-grey">Created at:</span> {{ this.$store.state.user.created_at }}</p>
        <p><span class="has-text-grey">Updated at:</span> {{ this.$store.state.user.updated_at }}</p>
      </div>

      <div class="column is-2">
        <div class="field is-grouped">
          <div class="control">
            <router-link v-bind:to="`/users/${this.$store.state.user.id}/edit`" class="button is-primary is-outlined">
              <span class="icon"><i class="fa fa-lg fa-pencil"></i></span>
              <span>Edit</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <hr>

    <div class="columns">
      <div class="column is-10 is-offset-1">
        <h5 class="subtitle is-5 has-text-centered has-text-blue-gray">Smart things</h5>
        <table class="table is-striped is-fullwidth">
          <thead>
            <tr>
              <th>ID</th>
              <th>Role</th>
              <th>Name</th>
              <th>Identifier</th>
              <th>Created at</th>
              <th>Updated at</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!this.$store.state.ownedThings.length && !this.$store.state.sharedThings.length && !this.$store.state.invitedThings.length">
              <td colspan="6" class="has-text-centered has-text-grey">No smart things found</td>
            </tr>
            <tr v-for="item in this.$store.state.ownedThings">
              <td>{{ item.id }}</td>
              <td><span class="tag badge-owner">owner</span></td>
              <td><router-link v-bind:to="`/products/${item.product_id}/things/${item.id}`">{{ item.name }}</router-link></td>
              <td>{{ item.identifier }}</td>
              <td>{{ item.created_at }}</td>
              <td>{{ item.updated_at }}</td>
            </tr>
            <tr v-for="item in this.$store.state.sharedThings">
              <td>{{ item.id }}</td>
              <td><span class="tag badge-guest">guest</span></td>
              <td><router-link v-bind:to="`/products/${item.product_id}/things/${item.id}`">{{ item.name }}</router-link></td>
              <td>{{ item.identifier }}</td>
              <td>{{ item.created_at }}</td>
              <td>{{ item.updated_at }}</td>
            </tr>
            <tr v-for="item in this.$store.state.invitedThings">
              <td>{{ item.id }}</td>
              <td><span class="tag badge-invitee">invitee</span></td>
              <td><router-link v-bind:to="`/products/${item.product_id}/things/${item.id}`">{{ item.name }}</router-link></td>
              <td>{{ item.identifier }}</td>
              <td>{{ item.created_at }}</td>
              <td>{{ item.updated_at }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <hr>

    <div class="columns">
      <div class="column is-10 is-offset-1">
        <h5 class="subtitle is-5 has-text-centered has-text-blue-gray">Mobile devices</h5>
        <table class="table is-striped is-fullwidth">
          <thead>
            <tr>
              <th>ID</th>
              <th>Model</th>
              <th>Manufacturer</th>
              <th>Platform</th>
              <th>Version</th>
              <th>Created at</th>
              <th>Updated at</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!this.$store.state.userDevices.length">
              <td colspan="7" class="has-text-centered has-text-grey">No mobile devices found</td>
            </tr>
            <tr v-for="item in this.$store.state.userDevices">
              <td>{{ item.id }}</td>
              <td>{{ item.model }}</td>
              <td>{{ item.manufacturer }}</td>
              <td>{{ item.platform }}</td>
              <td>{{ item.platform_ver }}</td>
              <td>{{ item.created_at }}</td>
              <td>{{ item.updated_at }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created () {
      this.$store.dispatch('getUser', {
        userId: this.$route.params.user_id,
        params: {
          include: 'owned_things,shared_things,invited_things,devices'
        }
      })
    }
  }
</script>

<style>
  .has-text-blue-gray {
    color: #607D8B;
  }
</style>



// WEBPACK FOOTER //
// UserView.vue?358fef7c